import React from 'react';
import { AclFeaturesList } from '../AclFeaturesList';

const PoliciesList = () => <AclFeaturesList feature="policy" apiPrefix="/acls/policies" resourceName="policies" />;

export { PoliciesList };
